export { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
export type { ConfirmationDialogData } from '../components/confirmation-dialog/confirmation-dialog.component';
export type { ConfirmationDialogField } from '../components/confirmation-dialog/confirmation-dialog.component';
export { createDeviceStatusConfirmationDetails } from '../components/confirmation-dialog/device-status-confirmation-details';
